import { render } from "./LogoWarning.vue?vue&type=template&id=7c2f2e14&scoped=true"
const script = {}

import "./LogoWarning.vue?vue&type=style&index=0&id=7c2f2e14&lang=sass&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c2f2e14"]])

export default __exports__